import { Mail, Phone } from 'lucide-react';

const PrivacyPolicyPage = () => {
  const sections = [
    {
      title: 'Introduction',
      content: [
        'Welcome to AgriMocks. We are committed to safeguarding the privacy of our users. This policy details how we handle your personal information when you use our services.'
      ]
    },
    {
      title: 'Information We Collect',
      content: [
        'Personal Information: When you register or interact with our platform, we may collect personal details such as your name, email address, contact number, educational background, and any other information you provide.',
        'Usage Data: We gather data on how you access and use our website, including your IP address, browser type, pages visited, and the time and date of your visits.',
        'Cookies: Our website uses cookies to enhance user experience. Cookies are small files stored on your device that help us analyze web traffic and customize our services. You can choose to accept or decline cookies through your browser settings.'
      ]
    },
    {
      title: 'How We Use Your Information',
      content: [
        'We utilize the collected information for purposes such as:',
        '• Providing and improving our services.',
        '• Personalizing user experience.',
        '• Processing transactions and sending related information.',
        '• Communicating with you, including sending updates and promotional materials.',
        '• Enhancing website security and preventing fraudulent activities.'
      ]
    },
    {
      title: 'Data Sharing and Disclosure',
      content: [
        'We do not sell or rent your personal information to third parties. However, we may share data with:',
        'Service Providers: Trusted third-party companies that assist us in operating our website and conducting our business, provided they agree to keep this information confidential.',
        'Legal Requirements: If required by law or in response to valid requests by public authorities.'
      ]
    },
    {
      title: 'Data Security',
      content: [
        'We implement appropriate security measures to protect your personal information from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet is entirely secure, and we cannot guarantee absolute security.'
      ]
    },
    {
      title: 'Your Rights',
      content: [
        'You have the right to:',
        '• Access and review the personal data we hold about you.',
        '• Request corrections to any inaccurate or incomplete information.',
        '• Withdraw consent to our data processing activities, where applicable.',
        '• Request deletion of your personal data, subject to legal obligations.'
      ]
    },
    {
      title: 'Third-Party Links',
      content: [
        'Our website may contain links to external sites. We are not responsible for the privacy practices or content of these third-party websites. We encourage you to review their privacy policies before providing any personal information.'
      ]
    },
    {
      title: 'Changes to This Privacy Policy',
      content: [
        'We may update this policy periodically to reflect changes in our practices or for other operational, legal, or regulatory reasons. We will notify you of any significant changes by posting the new policy on this page.'
      ]
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-green-600 to-green-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Privacy Policy</h1>
          <p className="text-xl text-green-100 max-w-3xl mx-auto">
            Your privacy is important to us. Learn how we protect and manage your data.
          </p>
        </div>
      </section>

      {/* Privacy Policy Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div key={index} className="bg-white dark:bg-gray-800 rounded-[24px] p-8 shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                  {index + 1}. {section.title}
                </h2>
                <div className="space-y-4">
                  {section.content.map((paragraph, pIndex) => (
                    <p key={pIndex} className="text-gray-600 dark:text-gray-300">
                      {paragraph}
                    </p>
                  ))}
                </div>
              </div>
            ))}

            {/* Contact Section */}
            <div className="bg-white dark:bg-gray-800 rounded-[24px] p-8 shadow-lg">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                9. Contact Us
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                If you have any questions or concerns about this privacy policy or our data practices, please contact us at:
              </p>
              <div className="space-y-4">
                <div className="flex items-center text-gray-600 dark:text-gray-300">
                  <Mail className="h-5 w-5 mr-3 text-green-600 dark:text-green-400" />
                  <span>agrimocks2025@gmail.com</span>
                </div>
                <div className="flex items-center text-gray-600 dark:text-gray-300">
                  <Phone className="h-5 w-5 mr-3 text-green-600 dark:text-green-400" />
                  <span>Contact number will be updated soon</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage; 